export class BankingCashCountHistoryDto {
    createdDate: Date;
    merchantServiceTimeId: number;
    currencyId: number;
    type: string;
    countedWhen?: string;
    countedTimes?: number;
    lastModifiedUser: string;
    lastModifiedEmployeeName?: string;
    posDeviceId?: number;
    sweetFaceTerminalId?: number;
    posDeviceName?: string;
    merchantId: number;
    day: string;
  }
  